import project from '../project.config'
export const BASE_ROUTE = project.publicPath



// WEBPACK FOOTER //
// ./src/config.js